import { EnrollmentTypes, OrderStatusTypes } from '../enums';

export interface OrderPayment {
  OrderPaymentId: number;
  ConsumerId?: number;
  ReferenceIdent?: string;
}

export interface OrderReview {
  OrderReviewId: string;
  Score?: number | null;
}

export interface Order {
  OrderId: number;
  OrderGuid?: string;
  EmployeeId?: number;
  StatusType: OrderStatusTypes;
  EnrollmentType: EnrollmentTypes;
  AmountTotal: number;
  StartDateTime: string;
  OrderPayments: OrderPayment[];
  OrderReviews: OrderReview[];
  OriginSDK: boolean;
}

export interface OrderTableDisplay {
  OrderId: number;
  Employee: string;
  StatusType: string;
  EnrollmentType: string;
  AmountTotal: number;
  StartDateTime: string;
  Score?: number | null;
  OrderGuid?: string;
  ReferenceIdent?: string;
  OriginSDK: boolean;
}
